import React from 'react';
import { useSelector } from 'react-redux';
import { Tab } from '@gumtree/ui-library';
import { CINCH_CAR_ACCOUNT_ID } from '@gumtree/shared/src/constants/cinch-car';

import { StyledTabs, ImageCarouselNoTabs, MapNoTabs } from './map-tab.style';
import { VipState } from '../../reducers';

import CarouselGallery from '../carousel-gallery/index.container';
import Video from './video';
import MapTab from './map-tab';

export const ImagesMapTabs: React.FC = () => {
    const {
        images,
        video = { urls: [] },
        mapDetails,
        baseConfig,
        isSellerCinchCar,
    } = useSelector(
        (state: VipState) => {
            const isSellerCinchCar =
                state.partnerships?.accountId === CINCH_CAR_ACCOUNT_ID.toString();
            return { ...state, isSellerCinchCar };
        },
        () => true
    );

    const videoUrl = video.urls?.[0] ?? null;
    const showCarouselConditions = images && images.length > 0;
    const showMapConditions = (!isSellerCinchCar && mapDetails?.visibleOnMap) || false;
    const tabCount = [videoUrl, showCarouselConditions, showMapConditions].filter(Boolean).length;

    return (
        <>
            {tabCount > 1 ? (
                <StyledTabs withButtonNavigation>
                    {showCarouselConditions && (
                        <Tab title="Images" icon="camera">
                            <CarouselGallery
                                mediaLinks={images.map((image) => ({ type: 'image', link: image }))}
                            />
                        </Tab>
                    )}
                    {videoUrl && (
                        <Tab title="Video" icon="video">
                            <Video youtubeLink={videoUrl} />
                        </Tab>
                    )}
                    {showMapConditions && (
                        <Tab title="Map" icon="beacon" forceRender>
                            <MapTab mapDetails={mapDetails} baseConfig={baseConfig} />
                        </Tab>
                    )}
                </StyledTabs>
            ) : (
                <>
                    {showCarouselConditions && (
                        <ImageCarouselNoTabs>
                            <CarouselGallery
                                mediaLinks={images.map((image) => ({ type: 'image', link: image }))}
                            />
                        </ImageCarouselNoTabs>
                    )}
                    {videoUrl && <Video youtubeLink={videoUrl} />}
                    {showMapConditions && (
                        <MapNoTabs>
                            <MapTab baseConfig={baseConfig} mapDetails={mapDetails} />
                        </MapNoTabs>
                    )}
                </>
            )}
        </>
    );
};

export default ImagesMapTabs;
